var UserProfile = (function() {
  var full_name = "";
  var uid="";

  var getName = function() {
    return full_name;    // Or pull this from cookie/localStorage
  };

  var setName = function(name) {
    full_name = name;     
    // Also set this in cookie/localStorage
  };


  var getUid= function() {
    return uid;    // Or pull this from cookie/localStorage
  };

  var setUid = function(id) {
    uid = id;     
    // Also set this in cookie/localStorage
  };

  return {
    getName: getName,
    setName: setName,
    getUid:  getUid,
    setUid:  setUid
  }

})();

export default UserProfile;